module.exports = __webpack_public_path__ + "media/images/banner/free-shipping-campaign/banner-0301c7fc961e2546ad1bf2f18b6af503.png";